<template>
  <button
    class="form-stepper__button-next styled-button"
    :class="{ 't-99': isActive }"
    type="button"
    :aria-disabled="!isActive"
    :disabled="!isActive"
    @click="stepperContext.advanceStep"
  >
    <slot />
  </button>
</template>

<script>
export default {
  inject: ['stepperContext', 'formContext'],
  props: {
    requiredFields: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isActive() {
      if (!!this.formContext.errorFields.length) return false;

      for (let i = 0; i < this.requiredFields.length; i++) {
        if (!this.formContext.dirtyFields.includes(this.requiredFields[i])) {
          return false;
        }
      }

      return true;
    },
  },
};
</script>
